module.exports = __webpack_public_path__ + "img/Pattern05.05b426f0.png";